import React from 'react';
import { Alert, Divider } from '@mui/material';
import { useStyles } from './EvaluationResults.styles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { getProcessLabel } from '../../../utils/assessmentSessionProcess';
import { AssessmentSessionProcessTypeId } from '../../../services/exams/assessmentSession/assessments.types';
import { ButtonOne } from '../../ButtonOne/ButtonOne.component';

interface EvaluationResultsProps {
  succeeded: boolean;
  nextProcessId: AssessmentSessionProcessTypeId | null;
  onSuccessButtonClick: () => void;
}

export const EvaluationResults: React.FC<EvaluationResultsProps> = (props) => {
  const classes = useStyles();

  const { succeeded, nextProcessId, onSuccessButtonClick } = props;

  const calculateProcessLabel = (): string => {
    return nextProcessId !== null ? getProcessLabel(nextProcessId).toProcess : 'następnego procesu';
  };

  const getAlertContent = (): string => {
    const toProcess = calculateProcessLabel();
    return succeeded
      ? `Zostałeś/aś pomyślnie zakwalifikowany/a do ${toProcess}`
      : `Nie zostałeś/aś dopuszczony/a do ${toProcess}`;
  };

  return (
    <div className={classes.qualificationStatusReturn}>
      <Alert
        severity={succeeded ? 'success' : 'error'}
        iconMapping={{
          success: <CheckCircleOutlineIcon />,
          error: <ErrorOutlineOutlinedIcon />,
        }}
        style={{ textAlign: 'left', fontSize: '13px', marginBottom: '20px' }}
      >
        {getAlertContent()}
      </Alert>
      {succeeded && (
        <>
          <ButtonOne variant="outlined" className={classes.successButton} onClick={() => onSuccessButtonClick()}>
            Przejdź do {calculateProcessLabel()}
          </ButtonOne>
          <div>
            <Divider style={{ marginTop: '20px' }}>LUB</Divider>
          </div>
        </>
      )}
    </div>
  );
};
